// extracted by mini-css-extract-plugin
module.exports = {"formatter":"sql-module--formatter--3WL7C"};